import Swiper, {
    Pagination,
    Navigation
} from 'swiper';

// const heroSectionHPSwiper = new Swiper(".wp-hero-section-hp", {
//     loop: true,
// });

// if(heroSectionHPSwiper) {
//     const prevBtns = document.querySelectorAll('.wp-hero-section-home__prev');
//     const nextBtns = document.querySelectorAll('.wp-hero-section-home__next');

//     prevBtns.forEach(btn => {
//         btn.addEventListener('click', () => {
//             heroSectionHPSwiper.slidePrev();
//         })
//     })

//     nextBtns.forEach(btn => {
//         btn.addEventListener('click', () => {
//             heroSectionHPSwiper.slideNext();
//         })
//     })
// }

const testimonialSwiper = new Swiper(".wp-testimonials__swiper", {
    modules: [Pagination, Navigation],
    loop: true,
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});